export const initialState = {
  items: [],
  isLoading: false,
  error: null,
};
